import {cn} from "../libs/utils";

const ButtonNext = ({type = 'button', onClick, label = 'Continuar', className}) => {
    return (
        <button
            className={cn(
                'group flex items-center justify-center gap-2',
                'bg-gradient-to-r from-ecoprimary1 to-resecondary text-white',
                'hover:shadow-lg hover:shadow-blue-200 hover:scale-[1.02]',
                'active:scale-[0.98]',
                'py-3 px-6 rounded-lg font-semibold text-sm',
                'transition-all duration-300 ease-out',
                className
            )}
            type={type}
            onClick={() => onClick()}
        >
            <span>{label.replace(' →', '').replace('→', '')}</span>
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
        </button>
    );
};

export default ButtonNext;